import React from 'react';

interface LottoBallProps {
  number: number;
  powerball?: boolean;
  size?: 'sm' | 'md' | 'lg';
  title?: string;
}

const sizeClasses = {
  sm: 'w-8 h-8 text-sm',
  md: 'w-10 h-10 md:w-11 md:h-11 text-base',
  lg: 'w-12 h-12 md:w-14 md:h-14 text-xl md:text-2xl',
};

const LottoBall: React.FC<LottoBallProps> = ({ number, powerball = false, size = 'md', title }) => {
  return (
    <div
      title={title}
      aria-label={`${powerball ? 'Power Ball' : 'Lotto ball'} ${number}`}
      className={`relative shrink-0 rounded-full flex items-center justify-center font-black font-mono select-none overflow-hidden ${sizeClasses[size]} ${
        powerball
          ? 'text-white border border-red-300/70 shadow-[0_5px_14px_rgba(220,38,38,0.42)] bg-[radial-gradient(circle_at_32%_26%,#fecaca_0%,#ef4444_24%,#b91c1c_63%,#450a0a_100%)]'
          : 'text-slate-900 border border-white/70 shadow-[0_5px_14px_rgba(0,0,0,0.38)] bg-[radial-gradient(circle_at_32%_24%,#ffffff_0%,#f8fafc_25%,#cbd5e1_64%,#64748b_100%)]'
      }`}
    >
      <span className="absolute top-[10%] left-[18%] w-[34%] h-[20%] rounded-full bg-white/75 blur-[1px] rotate-[-20deg]" />
      <span className={`absolute inset-[11%] rounded-full border ${powerball ? 'border-red-100/25' : 'border-white/60'}`} />
      <span className="relative z-10 drop-shadow-[0_1px_0_rgba(255,255,255,0.45)]">{number}</span>
    </div>
  );
};

export default LottoBall;
